










import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import {
  stripeElementsFontCssSrc,
  stripeElementsFontFamily,
} from '@/utils/stripe-styles'

@Component
export default class CreditCardInput extends Vue {
  @Prop() sdkLoaded!: boolean
  @Prop() useEurStripeAccount!: boolean

  private stripe!: stripe.Stripe
  private stripeElements!: stripe.elements.Elements
  private stripeCardNumber!: stripe.elements.Element
  private stripeCardExpiry!: stripe.elements.Element
  private stripeCardCvc!: stripe.elements.Element

  private readonly defaultElementOptions = {
    style: {
      base: {
        fontFamily: stripeElementsFontFamily,
        '::placeholder': {
          color: '#8D8D8D',
        },
      },
      invalid: {
        color: '#b94a48',
      },
    },
  }

  private errorsByElementType: { [elementType: string]: string | null } = {}

  @Watch('sdkLoaded')
  buildStripeElements(value: boolean) {
    if (!value) {
      return
    }

    this.stripe = this.useEurStripeAccount
      ? Stripe(`${process.env.VUE_APP_STRIPE_EUR_ACC_PK}`)
      : Stripe(`${process.env.VUE_APP_STRIPE_PK}`)

    this.stripeElements = this.stripe.elements({
      fonts: [{ cssSrc: stripeElementsFontCssSrc }],
    })
    this.stripeCardNumber = this.stripeElements.create('cardNumber', {
      ...this.defaultElementOptions,
      placeholder: 'Card Number',
    })
    this.stripeCardExpiry = this.stripeElements.create(
      'cardExpiry',
      this.defaultElementOptions,
    )
    this.stripeCardCvc = this.stripeElements.create(
      'cardCvc',
      this.defaultElementOptions,
    )

    this.stripeCardNumber.mount('.credit-card-input__number')
    this.stripeCardExpiry.mount('.credit-card-input__expiry')
    this.stripeCardCvc.mount('.credit-card-input__cvc')

    this.stripeCardNumber.on('change', (event) => {
      event && this.handleErrorOnChange(event)
    })
    this.stripeCardExpiry.on('change', (event) => {
      event && this.handleErrorOnChange(event)
    })
    this.stripeCardCvc.on('change', (event) => {
      event && this.handleErrorOnChange(event)
    })
  }

  mounted() {
    this.buildStripeElements(this.sdkLoaded)
  }

  handleErrorOnChange(event: stripe.elements.ElementChangeResponse) {
    const elementType = (event as stripe.elements.ElementChangeResponse & {
      elementType: string
    }).elementType
    if (event.error && event.error.message) {
      this.errorsByElementType[elementType] = event.error.message
    } else {
      this.errorsByElementType[elementType] = null
    }

    const compactedErrors = Object.keys(this.errorsByElementType)
      .map((elType: string) => this.errorsByElementType[elType])
      .filter((error: string | null) => error)
    this.$emit('on-card-error', compactedErrors)
  }

  getStripePaymentMethod(
    cardholderName: string,
  ): Promise<stripe.PaymentMethodResponse> {
    return this.stripe.createPaymentMethod('card', this.stripeCardNumber, {
      billing_details: {
        name: cardholderName,
      },
    })
  }

  clearFields(): void {
    this.stripeCardNumber.clear()
    this.stripeCardExpiry.clear()
    this.stripeCardCvc.clear()
  }
}
